import moment from 'moment'

/**
 * Normalise bundle or API date strings (e.g. ISO with time) to YYYY-MM-DD for Maldives charter
 * calendar leg matching (outbound arrival = hotel check-in, inbound departure = hotel check-out).
 */
export function charterCalendarDayKey(value: string | undefined): string | undefined {
  if (!value?.trim()) {
    return undefined
  }
  // Parse with the input's own offset so the calendar day matches the source
  // (e.g. AEST flight times) regardless of the runtime timezone.
  const parsed = moment.parseZone(value)
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : undefined
}
